'use client';

import { c as _c } from "react/compiler-runtime";
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/solid';
import { type ComponentPropsWithRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { TextField } from '@src/components/TextField/TextField';
import { PASSWORD_RULES, type PasswordRuleText, type PasswordSchema } from '@src/constants/PasswordSchema';
import { useLocale } from '@src/i18n/LocaleProvider';
import { cn } from '@src/utils/tailwind';
import { PasswordRule } from './PasswordRule';
type PasswordFieldProps = ComponentPropsWithRef<'input'> & {
  ruleText: PasswordRuleText;
  isDarkMode?: boolean;
};
export const PasswordField = props => {
  const $ = _c(31);
  const {
    t: ts
  } = useLocale("user-registration-form");
  const {
    t
  } = useLocale("user-registration-form-errors");
  const {
    watch,
    register,
    formState: t0
  } = useFormContext();
  const {
    errors
  } = t0;
  const password = watch("password") ?? "";
  const errorMessage = errors.password?.message;
  const hasErrors = !!errorMessage;
  let rest;
  let ruleText;
  if ($[0] !== props) {
    ({
      ruleText,
      ...rest
    } = props);
    $[0] = props;
    $[1] = rest;
    $[2] = ruleText;
  } else {
    rest = $[1];
    ruleText = $[2];
  }
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const IconRight = isPasswordVisible ? EyeSlashIcon : EyeIcon;
  let t1;
  if ($[3] !== props.disabled) {
    t1 = cn("w-full pt-4", {
      "opacity-20": props.disabled
    });
    $[3] = props.disabled;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = isPasswordVisible ? "text" : "password";
  let t3;
  if ($[5] !== ts) {
    t3 = ts("password");
    $[5] = ts;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== register) {
    t4 = register("password", {
      shouldUnregister: false
    });
    $[7] = register;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isPasswordVisible) {
    t5 = () => {
      setPasswordVisible(!isPasswordVisible);
    };
    $[9] = isPasswordVisible;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== IconRight || $[12] !== t5) {
    t6 = <IconRight className="cursor-pointer" onClick={t5} />;
    $[11] = IconRight;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = !!errorMessage;
  let t8;
  if ($[14] !== errorMessage || $[15] !== t) {
    t8 = t(errorMessage);
    $[14] = errorMessage;
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== rest || $[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8) {
    t9 = <TextField type={t2} id="password" data-testid="password" labelText={t3} {...t4} iconRight={t6} isInvalid={t7} captionText={t8} {...rest} />;
    $[17] = rest;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const t10 = "mt-4 flex flex-col gap-1";
  const t12 = PASSWORD_RULES.map(t11 => {
    const {
      regex,
      key
    } = t11;
    return <PasswordRule key={key} isValid={!!password && regex.test(password)} hasErrors={hasErrors} content={ruleText[key]} isDarkMode={props.isDarkMode} />;
  });
  let t13;
  if ($[25] !== t12) {
    t13 = <div className={t10}>{t12}</div>;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t1 || $[28] !== t13 || $[29] !== t9) {
    t14 = <div className={t1}>{t9}{t13}</div>;
    $[27] = t1;
    $[28] = t13;
    $[29] = t9;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
};